export default __webpack_public_path__ + "static/media/cvv.4d0d5a23.png";